<ng-container *ngIf="show">
  <div class="tb-cont">
    <awc-menu-bar
      [items]="items"
    ></awc-menu-bar>
  </div>
</ng-container>
